// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "SelfServQuestion" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { SelfServQuestionResponseGenShape } from "./self-serv-question-response.gen";

export const SelfServQuestionGenShape = z.strictObject({
  text: z.string(),
  name: z.string().optional(),
  slug: z.string().optional(),
  info: z.string().optional(),
  responses: z.array(SelfServQuestionResponseGenShape),
  entryPoint: z.boolean().optional(),
  tagId: z.string().optional(),
  variableId: z.string().optional(),
  relatedQuestionId: z.string().optional(),
  errors: z.array(z.string()).optional(),
  lastEdited: z.string().optional(),
  id: z.string(),
});
